import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Connected from "./Connected";
import {
    AppStoreButton,
    DesktopButton,
    FDroidButton,
    PlayStoreButton,
    WebButton,
} from "./DownloadButtons";
import { DownloadURL } from "constants/download";
import { useLocation } from "@reach/router";
import { URLwithUTMSuffix } from "utils/download";
import { useTranslation } from "react-i18next";

const FooterDownloadSection = styled.section.attrs({
    className: "container pt-5 pb-6 vstack gap-3",
})``;

const Platforms = styled.div.attrs({
    className: "text-center",
})`
    padding-top: 150px;
    margin: 0;
`;

const SecondaryHeading = styled.h2`
    color: var(--bs-code-color);
    font-style: normal;
    font-weight: 800;
    line-height: 120%;
    margin: 0 auto;
    margin-top: 56px;
    max-width: 90%;

    @media (min-width: 992px) {
        font-size: 56px;
        max-width: 750px;
    }
`;

const SecondarySubHeading = styled.div`
    font-size: 18px;
    margin-top: 24px;

    @media (min-width: 992px) {
        font-size: 20px;
    }
`;

const AnimatedConnected = styled(Connected)`
    transform-origin: 37px 40px;
    animation: spin 3s linear infinite;
`;

const FooterDownloads: React.FC = () => {
    const location = useLocation();
    const [pathname, setPathname] = useState("");

    useEffect(() => {
        setPathname(location.pathname);
    }, [location.pathname]);

    const isTakeControlPath =
        pathname === "/take-control" || pathname === "/take-control/";

    let pageIDForCTA = "";

    if (isTakeControlPath) {
        pageIDForCTA = "take-control";
    } else {
        pageIDForCTA = "photos";
    }

    const { t, i18n } = useTranslation();

    return (
        <FooterDownloadSection id="download">
            <Platforms>
                <AnimatedConnected />
                <SecondaryHeading>
                    {isTakeControlPath
                        ? "Keep your photos where they belong — safe, private, and under your control"
                        : t("EP_INDEX_FOOTER_DOWNLOADS_TITLE")}
                </SecondaryHeading>
                {!isTakeControlPath && (
                    <SecondarySubHeading>
                        {t("EP_INDEX_FOOTER_DOWNLOADS_DESCRIPTION")}
                    </SecondarySubHeading>
                )}
                <div className="d-flex flex-wrap mt-5 justify-content-center">
                    <PlayStoreButton
                        link={URLwithUTMSuffix(DownloadURL.googlePlay)}
                        source={`${pageIDForCTA}-footer-downloads`}
                    />
                    <AppStoreButton
                        link={URLwithUTMSuffix(DownloadURL.appStore)}
                        source={`${pageIDForCTA}-footer-downloads`}
                    />
                    <FDroidButton
                        link={DownloadURL.fDroid}
                        source={`${pageIDForCTA}-footer-downloads`}
                    />
                    <WebButton
                        link={DownloadURL.web}
                        source={`${pageIDForCTA}-footer-downloads`}
                    />
                    <DesktopButton
                        link={
                            i18n.language === "en"
                                ? "/download/desktop"
                                : `/${i18n.language}/download/desktop`
                        }
                        source={`${pageIDForCTA}-footer-downloads`}
                    />
                </div>
            </Platforms>
        </FooterDownloadSection>
    );
};

export default FooterDownloads;
